/** @format */
import "core-js/features/object/from-entries";
import "core-js/features/object/values";
import "core-js/features/object/assign";
import "core-js/stable"
import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import App from "./routes/routes";
import "./index.css";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./themes/tokens";
import { RecomendacaoProvider } from "./context/useRecomendacao";
import { PersonalizacaoProvider } from "./context/usePersonalizacao";
import { SessionProvider } from "./context/useSession";
import { FirebaseProvider } from "./context/useFirebase";

Modal.setAppElement("#root");

window.addEventListener("error", (e) => {
  if (
    e.message ===
      "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded" || "Javascript Error"
  ) {
    e.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <ChakraProvider theme={theme} resetCSS={true}>
    <React.StrictMode>
      <SessionProvider>
        <FirebaseProvider>
          <PersonalizacaoProvider>
            <RecomendacaoProvider>
              {/* <TabScrollRecomendacaoProvider> */}
              <App />
              {/* </TabScrollRecomendacaoProvider> */}
            </RecomendacaoProvider>
          </PersonalizacaoProvider>
        </FirebaseProvider>
      </SessionProvider>
    </React.StrictMode>
  </ChakraProvider>,
  document.getElementById("root")
);
